import React from 'react'
import { FaBullhorn } from "react-icons/fa";
import { Link } from 'react-router-dom';

import Spamkeyword from '../pages/images/wabachannel.png'
import SystemReport from '../pages/images/managetemplate.png'
import deliverymis from '../pages/images/managelibrery.png'
import TTS from '../pages/images/templateLibreary.png'
import bulkUpload from '../pages/images/bulkUpload.png'
import unsubscibe from '../pages/images/unsubscibe.png'
import tts from '../pages/images/tts (1).png'
import whitemenu from '../pages/images/white-menu.png'


const ReportingTools = [
    {
        title: "Waba Channels",
        description: "Easily Connect and manage WABA Channels.",
        slug: "/WAMessage/WABAChannels/Index",
        image: Spamkeyword
    },
    {
        title: "Manage Template",
        description: "Easily Manage your WhatsApp Template.",
        slug: "/WAMessage/WATemplate/Index",
        image: SystemReport
    },
    {
        title: "Template Library",
        description: "Browse approved template library.",
        slug: "/WAMessage/Templatelibrary/Index",
        image: deliverymis
    },
    {
        title: "Media Library",
        description: "Browse media library.",
        slug: "/WAMessage/WAMediaLibrary/Index",
        image: TTS
    }
];
const ContactManager = [
    {
        title: "Unsubscriber Number List",
        description: "View and manage unsubscribed numbers.",
        slug: "/WAMessage/UnsubscribedNumbers/Index",
        image: unsubscibe
    },
    {
        title: "Manage Group",
        description: "Easily manage your groups here.",
        slug: "/Client/Groups/Index",
        image: tts
    },
    {
        title: "Blacklist Numbers",
        description: "Manage your blacklist for better control.",
        slug: "/Client/BlackListNumbers/Index",
        image: whitemenu
    }
];

function Config() {
    return (
        <>
            <div className='pl-6 dark:bg-[#121519] w-[100%]'>
                <div className='border-[1px] border-[#d6d4d4] w-[100%] p-2 rounded-md  dark:bg-[#121519] '>
                    <div className='  flex justify-between w-[100%] pl-2 pb-2 border-[#d6d4d4] border-b-[1px] '>
                        <div className='flex items-center gap-1 '>
                            <FaBullhorn className='text-[18px] dark:text-[#fff]' />
                            <span className='text-[14px] text-[#000] font-semibold dark:text-[#fff]'> Channel & Templates Management
                            </span>
                        </div>
                    </div>
                    <div className='w-[100%] flex gap-4 flex-wrap  items-center pt-3 pb-5 '>
                        {ReportingTools.map((item, index) => (
                            <div className='text-white border-0 rounded-[20px] py-8 px-1 
        w-full sm:w-[48%] md:w-[30%] lg:w-[22%] xl:w-[15%]
        h-[160px] cursor-pointer text-center 
        [transform-style:preserve-3d] transition-all duration-300 ease-in-out 
        shadow-[0_12px_24px_rgba(0,0,0,0.2),0_6px_10px_rgba(0,0,0,0.1)] 
        hover:shadow-[rgba(0,0,0,0.35)_0px_5px_15px] 
        flex flex-col items-center  duration-400  hover:[transform:rotateX(12deg)_rotateY(-12deg)] group '>
                                <Link to={item.slug}>
                                    <div className='w-[100%] flex justify-center items-center'>
                                        <img className='w-[48px]' src={item.image} alt="" />
                                    </div>
                                    <h1 className='text-[#000] text-[14px] font-semibold transition-all duration-300 group-hover:-translate-y-1 group-hover:-translate-x-1 dark:text-[#fff]'>{item.title}</h1>
                                    <span className='text-[#777777] text-[12px] font-semibold text-center dark:text-[#fff] leading-tight line-clamp-2'>{item.description}</span>
                                </Link>
                            </div>
                        ))
                        }

                    </div>
                    <div>

                    </div>
                </div>
                <div className='border-[1px] border-[#d6d4d4] w-[100%] p-2 rounded-md  dark:bg-[#121519] mt-6 '>
                    <div className='  flex justify-between w-[100%] pl-2 pb-2 border-[#d6d4d4] border-b-[1px] '>
                        <div className='flex items-center gap-1 '>
                            <FaBullhorn className='text-[18px] dark:text-[#fff]' />
                            <span className='text-[14px] text-[#000] font-semibold dark:text-[#fff]'> Contact Manager
                            </span>
                        </div>
                    </div>
                    <div className='w-[100%] flex gap-4 flex-wrap  items-center pt-3 pb-5 '>
                        {ContactManager.map((item, index) => (
                            <div className='text-white border-0 rounded-[20px] py-8 px-1 
        w-full sm:w-[48%] md:w-[30%] lg:w-[22%] xl:w-[15%]
        h-[160px] cursor-pointer text-center 
        [transform-style:preserve-3d] transition-all duration-300 ease-in-out 
        shadow-[0_12px_24px_rgba(0,0,0,0.2),0_6px_10px_rgba(0,0,0,0.1)] 
        hover:shadow-[rgba(0,0,0,0.35)_0px_5px_15px] 
        flex flex-col items-center  duration-400  hover:[transform:rotateX(12deg)_rotateY(-12deg)] group '>

                                <Link to={item.slug}>
                                    <div className='w-[100%] flex justify-center items-center'>
                                        <img className='w-[48px]' src={item.image} alt="" />
                                    </div>
                                    <h1 className='text-[#000] text-[14px] font-semibold transition-all duration-300 group-hover:-translate-y-1 group-hover:-translate-x-1 dark:text-[#fff]'>{item.title}</h1>
                                    <span className='text-[#777777] text-[12px] font-semibold text-center dark:text-[#fff] leading-tight line-clamp-2'>{item.description}</span>
                                </Link>
                            </div>

                        ))
                        }

                    </div>
                    <div>

                    </div>
                </div>

            </div >
        </>
    )
}

export default Config
